import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Router from '@/router';
import settingsPanelBtns from "../../i18n/ru-ru/instruments/settings";
var settingsPanelBtnNames = settingsPanelBtns.map(function (btn) {
  return btn.filterModalName;
});
var settings = {};
settingsPanelBtnNames.forEach(function (item) {
  settings[item] = {
    name: undefined,
    code: undefined,
    shopName: undefined
  };
});
var staff = {
  lastName: undefined,
  userName: undefined,
  groupList: undefined,
  workTypesList: undefined
};
var timetable = {
  staff: {
    lastName: undefined,
    userName: undefined,
    workersFilter: undefined,
    workTypesFilter: undefined,
    workerTypesFilter: undefined
  }
};
var state = {
  modal: undefined,
  from: undefined,
  to: undefined,
  deps: undefined,
  coverage: '',
  tableView: '',
  tableDisplay: '',
  mainWorkTypes: undefined,
  vacancyFilterFree: undefined,
  vacancyFilterApproved: undefined,
  includeOutsource: undefined,
  internalExchange: undefined,
  internalOrOutsourcesIds: undefined,
  mbVacancy: undefined,
  forecastChartType: undefined,
  outsourcingsVacancyExchange: undefined,
  timetable: timetable,
  settings: settings,
  staff: staff,
  _panelName: '',
  _queryString: '',
  _checkStaff: []
};
var queryKeys = Object.keys(state).filter(function (key) {
  return key[0] !== '_';
});
var mutations = {
  handleRouteChanges: function handleRouteChanges(state, _ref) {
    var newRoute = _ref.newRoute;
    var routeQueryKeys = Object.keys(newRoute.query);
    var noSettedKeys = queryKeys.filter(function (key) {
      return !routeQueryKeys.includes(key);
    });
    noSettedKeys.forEach(function (key) {
      if (_typeof(state[key]) !== 'object') {
        state[key] = undefined;
      } else {
        replaceString(state[key], key);
      }
    });

    function replaceString(obj, nestingPath) {
      for (var key in obj) {
        if (_typeof(obj[key]) !== 'object') {
          if (!routeQueryKeys.includes("".concat(nestingPath, ">").concat(key))) {
            obj[key] = undefined;
          }
        } else {
          replaceString(obj[key], "".concat(nestingPath, ">").concat(key));
        }
      }
    }

    routeQueryKeys.forEach(function (key) {
      var newQueryParam = newRoute.query[key];
      var stateValue = key.split('>').reduce(function (acc, item) {
        return acc === null || acc === void 0 ? void 0 : acc[item];
      }, state);

      if (newQueryParam !== stateValue) {
        key.split('>').reduce(function (acc, item) {
          if (acc === 'setted') {
            return acc;
          } else if (_typeof(acc === null || acc === void 0 ? void 0 : acc[item]) !== 'object') {
            if (key === 'deps' && newQueryParam) {
              acc[item] = newQueryParam.split(',').filter(function (el) {
                return el;
              }).join();
            } else {
              acc[item] = newQueryParam || undefined;
            }

            return 'setted';
          } else {
            return acc === null || acc === void 0 ? void 0 : acc[item];
          }
        }, state);
      }
    });
    state._panelName = newRoute.path.split('/')[1];
    state._queryString = newRoute.fullPath.split('?')[1];
  },
  setCheckStaff: function setCheckStaff(state, value) {
    state._checkStaff = value;
  },
  setValue: function setValue(state, _ref2) {
    var entity = _ref2.entity,
        value = _ref2.value;
    state[entity] = value;
  }
};
var actions = {
  deleteParam: function deleteParam(_, _ref3) {
    var name = _ref3.name;

    var queryCopy = _objectSpread({}, Router.currentRoute.query);

    delete queryCopy[name];
    Router.push({
      query: queryCopy
    }).catch(function (e) {
      return e;
    });
  },
  deletePanelParams: function deletePanelParams(_, _ref4) {
    var panelName = _ref4.panelName;

    var queryCopy = _objectSpread({}, Router.currentRoute.query);

    var matchedKeys = Object.keys(queryCopy).filter(function (queryKey) {
      return queryKey.includes("".concat(panelName, ">"));
    });
    matchedKeys.forEach(function (matchedKey) {
      delete queryCopy[matchedKey];
    });
    Router.push({
      query: queryCopy
    }).catch(function (e) {
      return e;
    });
  },
  setParam: function setParam(_ref5, _ref6) {
    var dispatch = _ref5.dispatch;
    var name = _ref6.name,
        value = _ref6.value,
        _ref6$finalized = _ref6.finalized,
        finalized = _ref6$finalized === void 0 ? false : _ref6$finalized;
    var query = {};

    if (name === 'deps' && value) {
      query[name] = value.split(',').filter(function (el) {
        return el;
      }).join();
    } else {
      query[name] = value;
    }

    if (!finalized) {
      query['f'] = '0';
    }

    if (value === '') {
      dispatch('deleteParam', {
        name: name
      });
    } else {
      Router.replace({
        query: query
      }).catch(function (e) {}); // https://github.com/vuejs/vue-router/issues/2873
    }
  },
  setParams: function setParams(context, _ref7) {
    var elements = _ref7.elements,
        finalized = _ref7.finalized;
    var query = {};
    elements.forEach(function (item) {
      if (item.name === 'deps' && item.value) {
        query[item.name] = item.value.split(',').filter(function (el) {
          return el;
        }).join();
      } else {
        query[item.name] = item.value;
      }
    });
    if (!finalized) query['f'] = '0';
    Router.push({
      query: query
    }).catch(function (e) {});
  },
  resetInstrumentValues: function resetInstrumentValues(_ref8) {
    var state = _ref8.state,
        dispatch = _ref8.dispatch;

    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        exactValues = _ref9.exactValues;

    if (exactValues) {
      exactValues.forEach(function (value) {
        dispatch('deleteParam', {
          name: value
        });
      });
    } else {
      dispatch('deletePanelParams', {
        panelName: state._panelName
      });
    }
  }
};
var getters = {
  getDeps: function getDeps() {
    var deps = state.deps;
    deps = deps && deps.split(',');
    deps = Array.isArray(deps) && deps.map(function (el) {
      return Number(el);
    });
    return deps || [];
  },
  getOneDep: function getOneDep() {
    var _state$deps, _state$deps$split;

    var result = (_state$deps = state.deps) === null || _state$deps === void 0 ? void 0 : (_state$deps$split = _state$deps.split(',')) === null || _state$deps$split === void 0 ? void 0 : _state$deps$split.slice(-1)[0];
    return result;
  },
  getSelectInternalOrOutsourcesIds: function getSelectInternalOrOutsourcesIds(state) {
    var ids = state.internalOrOutsourcesIds;
    ids = ids && ids.split(',');
    ids = Array.isArray(ids) && ids.map(function (el) {
      return Number(el);
    });
    return ids || [];
  },
  getDownloadParams: function getDownloadParams() {
    return function () {
      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = {
        employee: getters.getCheckStaff().join(),
        deps: getters.getDeps(),
        from: state.from,
        to: state.to
      };
      Object.keys(queryParams).forEach(function (param) {
        queryParams[param] = params[queryParams[param]];
      });
      return params.employee.length && Object.keys(queryParams).length ? "?".concat(new URLSearchParams(queryParams)) : '';
    };
  },
  getCheckStaff: function getCheckStaff() {
    return state._checkStaff.filter(function (id) {
      return id;
    });
  },
  hasStaffFilterSet: function hasStaffFilterSet(state) {
    var _state$staff$lastName, _state$staff$userName, _state$staff$groupLis, _state$staff$workType;

    return Boolean(((_state$staff$lastName = state.staff.lastName) === null || _state$staff$lastName === void 0 ? void 0 : _state$staff$lastName.length) || ((_state$staff$userName = state.staff.userName) === null || _state$staff$userName === void 0 ? void 0 : _state$staff$userName.length) || ((_state$staff$groupLis = state.staff.groupList) === null || _state$staff$groupLis === void 0 ? void 0 : _state$staff$groupLis.length) || ((_state$staff$workType = state.staff.workTypesList) === null || _state$staff$workType === void 0 ? void 0 : _state$staff$workType.length));
  },
  hasTimetableStaffFilterSet: function hasTimetableStaffFilterSet(state) {
    return state.timetable.staff.workersFilter !== 'all' || state.timetable.staff.workTypesFilter !== 'all' || state.timetable.staff.workerTypesFilter !== 'all';
  },
  getTimetableStaffFilter: function getTimetableStaffFilter(state) {
    return function (filterName) {
      var filter = state.timetable.staff[filterName];

      if (filter === 'all') {
        return filter;
      }

      filter = filter && filter.split(',');
      filter = Array.isArray(filter) && (filterName === 'workerTypesFilter' ? filter : filter.map(function (el) {
        return Number(el);
      }));
      return filter || [];
    };
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};